<icz-section label="Základní" boxed class="block mb-32">
  @if(form) {
    <form [formGroup]="form">
      <icz-form-field
        label="Od koho"
        formControlName="senderEmailAddress"
      ></icz-form-field>
    </form>
  }
  <icz-email-metadata-preview
    [consignment]="consignment"
    [showSenderAddress]="false"
  ></icz-email-metadata-preview>
</icz-section>
